import { BaseDataService } from "../../../services/base/BaseDataService";
import { DocTemplateQuery } from "../models/DocTemplateQuery";
import { DocTemplate } from "../models/DocTemplate";

export class DocTemplateService extends BaseDataService<
  DocTemplate,
  DocTemplateQuery
> {
  protected prefixUrl = `DocTemplates`;
}